"use client";

import React from "react";

interface SelectedToken {
  img: string;
  cryptoName: string;
  cryptoSymbol: string;
  percentage: number;
  price: number;
}

export const StakingContext = React.createContext({
  selectedToken: {} as SelectedToken,
  setSelectedToken: (_value: SelectedToken) => {},
});

export function StakingProvider({ children }: { children: React.ReactNode }) {
  const [selectedToken, setSelectedToken] = React.useState({
    img: "/icons/bitcoin.svg",
    cryptoName: "Bitcoin",
    cryptoSymbol: "BTC",
    percentage: 2.37,
    price: 970000,
  });

  return (
    <StakingContext.Provider value={{ selectedToken, setSelectedToken }}>
      {children}
    </StakingContext.Provider>
  );
}
